<template>
  <div class="location-form">
    <wrld-box :headerTitle="$t('overview')" hideableContent>
      <template v-slot:boxContent>
        <v-container>
          <LocationFormOverview v-model="location.overview" :companyFilled="companyFilled"/>
        </v-container>
      </template>
    </wrld-box>
    <wrld-box :headerTitle="$t('locations.address')" hideableContent>
      <template v-slot:boxContent>
        <v-container>
          <LocationFormAddress v-model="location.address" :isUpdate="isUpdate"/>
        </v-container>
      </template>
    </wrld-box>
    <wrld-box :headerTitle="$t('locations.opening_hours')" hideableContent>
      <template v-slot:boxContent>
        <v-container>
          <LocationFormOpenings v-model="location.opening_hours"/>
        </v-container>
      </template>
    </wrld-box>
    <wrld-box :headerTitle="$t('locations.contact')" hideableContent v-if="!hideContacts">
      <template v-slot:boxContent>
        <v-container>
          <LocationFormContacts v-model="location.contacts"/>
        </v-container>
      </template>
    </wrld-box>
  </div>
</template>

<script>
import LocationFormOverview from '@/components/locations/LocationFormOverview.vue'
import LocationFormAddress from '@/components/locations/LocationFormAddress.vue'
import LocationFormOpenings from '@/components/locations/LocationFormOpenings.vue'
import LocationFormContacts from '@/components/locations/LocationFormContacts.vue'

export default {
  name: 'LocationsForm',
  components: {
    LocationFormOverview,
    LocationFormAddress,
    LocationFormOpenings,
    LocationFormContacts
  },
  props: {
    value: Object,
    companyFilled: {
      type: Boolean,
      default: false
    },
    isUpdate: {
      type: Boolean,
      default: false
    },
    hideContacts: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      location: JSON.parse(JSON.stringify(this.value))
    }
  },
  watch: {
    location: {
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
